import moment from '@/libs/moment'

export const PERIOD_DATE_FORMAT = 'YYYY-MM-DD'

export const emptyPeriod = () => ({
  invest_start_at: null,
  invest_end_at: null,
  trade_start_at: null,
  trade_end_at: null,
  premature_cancelation_period: null,
  premature_cancelation_fine_percent: null,
  fee_static: null,
  fee_percent: null,
  profit_share_percent: null,
  loss_share_percent: null,
})

export const PERIOD_DATE_KEYS = ['invest_start_at', 'invest_end_at', 'trade_start_at', 'trade_end_at']

// normalizes a period from the api (datetime strings, numeric strings) into form values
export const toPeriodForm = data => Object.keys(emptyPeriod()).reduce((period, key) => {
  const value = data?.[key]
  if (value === null || value === undefined || value === '') return { ...period, [key]: null }
  return {
    ...period,
    [key]: PERIOD_DATE_KEYS.includes(key) ? moment(value).format(PERIOD_DATE_FORMAT) : Number(value),
  }
}, {})

// invest window -> (freezing) -> trade window; trading may start on the day investing ends
export const isPeriodDateOrderValid = period => {
  const isInOrder = (first, second, allowSame = false) => {
    if (!first || !second) return true
    return allowSame ? !moment(second).isBefore(first) : moment(first).isBefore(second)
  }
  return isInOrder(period.invest_start_at, period.invest_end_at)
    && isInOrder(period.invest_end_at, period.trade_start_at, true)
    && isInOrder(period.trade_start_at, period.trade_end_at)
}
